<template>
  <svg
    width="11"
    height="10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="5.5"
      cy="5"
      r="5"
      :fill="`url(#${id}`"
    />
    <defs>
      <linearGradient
        :id="id"
        x1="1.75"
        y1="1"
        x2="9"
        y2="9.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#91FF53" />
        <stop
          offset="1"
          stop-color="#FF4F43"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  computed: {
    id() {
      return Math.random().toString(36).substr(2, 9);
    },
  },
};
</script>
